<template>
	<div class="xhorse-home">
		<x-header :path="$path"
				  :backColor="backColor"
				  :textColor="textColor"
				  :activeTopIndex="activeIndex.top"
				  :activeSideIndex="activeIndex.side"
				  @go="activeTo"></x-header>
		<div class="banner-area">
			<div class="banner-con">
				<img :src="source.banner" alt="Xhorse"/>
			</div>
			<!--<div class="slide_tips">
				<i class="s_line"></i>
				<span class="txt">Scroll</span>
			</div>-->
		</div>
		<div class="belong-area">
			<div class="belong-con">
				<div class="top-bar"></div>
				<div class="we-detail">
					<div class="content">
						<div class="item-con">
							<i class="x-ico-left"></i>
							<span class="txt">Science and Technology Dream	<br/> Beyond Imagination</span>
							<i class="x-ico-right"></i>
						</div>
						<div class="desc-con">
							<p>
								Xhorse, as a national level high-tech enterprise based on intelligent manufacturing, has been always exploring new possibilities for intelligent manufacturing and life, and committed to changing life through science and technology.</p>
						</div>
						<div class="detail-con">
							<ul class="detail-list">
								<li @mouseenter="viewload" @mouseleave="viewmiss">
									<router-link :to="{name : 'about', params: {
									    activeTop: [1,1], activeSide: [1]
									}}">
										<p class="">About Xhorse</p>
										<img :src="source.images.intr_bg" alt="About Xhorse"/>
									</router-link>
								</li>
								<li @mouseenter="viewload" @mouseleave="viewmiss">
									<router-link :to="{name : 'about', params: {
									    activeTop: [1,7], activeSide: [7]
									}}">
										<p class="">Address</p>
										<img :src="source.images.pos_bg" alt="Address"/>
									</router-link>
								</li>
								<li @mouseenter="viewload" @mouseleave="viewmiss">
									<router-link :to="{name : 'about', params: {
									    activeTop: [5,1], activeSide: [1]
									}}">
										<p class="">Join us</p>
										<img :src="source.images.join_bg" alt="Join us"/>
									</router-link>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="prod-detail">
					<div class="swiper-con">
						<el-carousel :interval="3000"
									 arrow="always"
									 indicator-position="outside"
									 class="carousel">
							<el-carousel-item v-for="item in source.swipe" :key="item" style="border-radius: 5px">
								<div class="swiper-item" style="border-radius: 5px">
									<ul>
										<li class="x-flow"><img :src="item.depend" alt="Xhorse"/></li>
										<li class="x-flow">
											<h3 v-if="item.key==4" class="margin-top-120">{{ item.title }}</h3>
											<h3 v-else>{{ item.title }}</h3>
											<ul class="sub-li" :style="{'margin-top': (item.key==4?'2rem':'1.25rem')}">
												<li v-for="myTxt in item.text">
													<template v-if="item.key==1">
														<div class="x-flow" style="width: 5%;border: none;"> ·
														</div>
														<div class="x-flow" style="width: 95%;border: none;">
															{{ myTxt }}
														</div>
													</template>
													<template v-else>
														{{ myTxt }}
													</template>
												</li>
											</ul>
										</li>
									</ul>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
				<div class="join-detail">
					<div class="apply-con">
						<ul>
							<li>
								<h3>Join Us Now! To be a member of the Xhorse Team. </h3>
								<p>
									To shape your future life. Let's hand in hand, to make the unconstrained dream of science and technology come true!</p>
								<ul class="btn-group">
									<router-link :to="{ name: 'join', params: {
									    activeTop: [5,3], activeSide: [3]
									} }">
										<li class="camps">
											<div class="txt">Campus Recruitment</div>
											<div class="hit"><i class="x-ico-apply"></i><span>Apply Now</span></div>
										</li>
									</router-link>
									<router-link :to="{ name: 'join', params: {
									    activeTop: [5,2], activeSide: [2]
									} }">
										<li class="social">
											<div class="txt">Social Recruitment</div>
											<div class="hit"><i class="x-ico-apply"></i><span>Apply Now</span></div>
										</li>
									</router-link>
								</ul>
							</li>
							<li class="mar-left"><img :src="source.images.applyImage"
													  alt="Xhorse"/></li>
						</ul>
					</div>
				</div>
				<div class="join-entry">
					<div class="entry-con">
						<ul>
							<li><p>
								Ready to join us? Click the recruitment details for more info.</p>
							</li>
							<li>
								<router-link to=""
											 @click.native="winLocateTo('https://jobs.51job.com/all/co3441454.html')">
									<div class="entry-btn">Recruitment Details</div>
								</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<x-footer :path="$path"></x-footer>
		<x-home :backVisible="backVisible" :backStyle="backStyle"></x-home>
	</div>
</template>

<script>
    import xHeader from '@/components/zh-cn/header.vue'
    import xFooter from '@/components/zh-cn/footer.vue'


    import banner from '@/assets/resource/images/home/banner_home_01.png'
    import intr_bg from '@/assets/resource/images/home/image_home_01.png'
    import pos_bg from '@/assets/resource/images/home/image_home_02.png'
    import join_bg from '@/assets/resource/images/home/image_home_03.png'

    import swipe_image1 from '@/assets/resource/images/home/image_home_product_01.png'
    import swipe_image2 from '@/assets/resource/images/home/image_home_product_02.png'
    import swipe_image3 from '@/assets/resource/images/home/image_home_product_03.png'
    import swipe_image4 from '@/assets/resource/images/home/image_home_product_04.png'
    import applyImage from "@/assets/resource/images/home/image_home_04.png"
    export default {
        name: 'index',
        components: {
            xHeader: xHeader,
            xFooter: xFooter,
            xHome: () => import('@/components/zh-cn/home')
        },
        data () {
            const _this = this;
            return {
                activeIndex: {
                    top: [],
                    side: []
                },
                textColor: '#FFFFFF',
                backColor: 'transparent',
                source: {
                    banner: banner,
                    images: {
                        intr_bg: intr_bg,
                        pos_bg: pos_bg,
                        join_bg: join_bg,
                        applyImage: applyImage
                    },
                    swipe: [
                        {
                            key: 1,
                            depend: swipe_image1,
                            title: "Desktop 5-axis engraving machine",
                            text: [
                                "Support 5-axis vector interpolation RTCP tool tip control;",
                                "Spline curve fairing technology;",
                                "High-speed forward-looking and speed smoothing technology;",
                                "Configure a unique optical scanning module to achieve rapid positioning of the workpiece;",
                                "Support virtual processing simulation for quickly verify of processing procedures;"
                            ]
                        },
                        {
                            key: 2,
                            depend: swipe_image2,
                            title: "Smart Electronic Lock",
                            text: ["The Smart Electronic Lock supports fingerprint recognition, password-protected door locking system, WiFi connection, access information record function, and system information configuration. It enables you to remotely open your door by using the cell phone App. The smart electronic lock also has a power detection function, which will prompt you to replace the battery when the power is too low."]
                        },
                        {
                            key: 3,
                            depend: swipe_image3,
                            title: "Xhorse ASIC Team",
                            text: ["The Xhorse semiconductor team consists of outstanding members who specialize in the field of design, verification, testing, and reliability of semiconductors.  The team has an incredible advantage in several aspects as low-power analog/digital, narrow-band radio frequency communication and algorithm, and security algorithm IP design. With years of unremitting R&D investment, the team has made great achievements in many fields such as RFID..."]
                        },
                        {
                            key: 4,
                            depend: swipe_image4,
                            title: "Optical key recognition tool",
                            text: ["Use the traditional light source to obtain key parameters such as Key blank shape, biting shape, and, contour. It enables users to greatly improve the speed of the key cutting process."]
                        },
                    ]
                },
                backVisible: false,
                backStyle: {
                    bottom: '3rem'
                }
            }
        },
        methods: {
            activeTo(params){
				/*console.log("Template[index]: ", params)*/

                const _this = this;
                const componentInfo = _this.$RegistedName;
                const dateTime = (new Date()).getTime()
                if (params.type == 'top') {
                    var fullPath = params.val.map((item) => {
                        if (toString(item).indexOf('-')) {
                            return parseInt(item.toString().split('-').reverse()[0]);
                        } else {
                            return parseInt(item);
                        }
                    });
                    _this.activeIndex.top = fullPath;
                    _this.activeIndex.side = fullPath.slice(-1);
                    _this.$router.push({name: componentInfo[fullPath[0]].componentName, params: {date: dateTime}})
                } else {
                    _this.activeIndex.side = params.val
                }
            },
            strReplace(val){
                return val.replace(/\s/g, "");
            },
            viewload: function (e) {
                const _this = this, ele = e.target;
            },
            viewmiss: function (e) {
                const _this = this, ele = e.target;
            },
            winLocateTo: function (url) {
                const _this = this;
                window.open(url, "_blank")
            },
            onAboutScroll(){
                const _this = this;
                const xheader = document.getElementById('x-header').getBoundingClientRect();
                const xfooter = document.getElementById('x-wrap-footer').getBoundingClientRect();
                const viewHeight = window.screen.availHeight;
                const viewWidth = window.screen.availWidth;
                try {
                    if (xheader.top < _this.$visibleHomeTop) {
                        _this.backVisible = true;
                        if ((xfooter.top / 16) <= (viewHeight / 16)) {
                            const realBottomEm =
                            ((viewHeight - xfooter.top) / 16) < 30 ?
                            (30 + 0.8125 + 'rem') : (((viewHeight - xfooter.top) / 16) + 0.8125 + 'rem');
                            const realBottomPx = (viewHeight - xfooter.top) + 'px';
                            _this.backStyle.bottom = viewWidth > 1240 ? realBottomPx : realBottomEm;
                        } else {
                            _this.backStyle.bottom = viewWidth > 1240 ? '48px' : '3rem';
                        }
                    } else {
                        _this.backVisible = false;
                    }
                } catch (err) {

                }

            }
        },
        mounted(){
            const _this = this;
            $("#x-header .h-li").css({color: '#FFFFFF'});
            window.addEventListener('scroll', _this.onAboutScroll, true);
        },
        created(){

        },
        destroyed(){
            const _this = this;
            window.removeEventListener('scroll', _this.onAboutScroll);
        },
        beforeRouteLeave (to, from, next) {
             if(['/software','/xhorseIM','/download'].includes(to.path)){
                next(true)
                return
             }

            const _this = this;
            var data = {
                side: _this.activeIndex.side,
                top: _this.activeIndex.top,
            };

            if (to.params.hasOwnProperty('activeTop') && to.params.hasOwnProperty('activeSide')) {
                data.side = to.params.activeSide;
                data.top = to.params.activeTop;
            }

            _this.$store.commit('setActivePath', {
                type: 'all',
                val: data
            });
            next(true)
        }


    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import "../../assets/css/index.css";
	@import "../../assets/css/spe.css";
</style>



// WEBPACK FOOTER //
// src/components/zh-cn/index.vue